<template>
	<div class="public_header bg_gray">
		<div class="w1200 flex">
			<div class="public_header_l">
				<ul>
					<li class="public_header_list"><router-link to="/" class="cl_dark">首页</router-link></li>
					<li class="public_header_list"><router-link to="/study" class="cl_dark">趣学习</router-link></li>
					<li class="public_header_list"><router-link to="/career" class="cl_dark">生涯规划</router-link></li>
					<li class="public_header_list"><router-link to="/wish" class="cl_dark">志愿填报</router-link></li>
					<li class="public_header_list"><router-link to="/news_list" class="cl_dark">高中资讯</router-link></li>
				</ul>
			</div>
			<div class="public_header_r" v-if="myInfo.name || myInfo.real_name || myInfo.wx_nickname">
				<router-link to="/vip_code" class="public_header_vip cl_violet f16px" v-if="myInfo.level_id == 0">激活</router-link>
				<div class="public_header_name">
					<span class="cl_dark">你好，</span>
					<i class="cl_violet f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</i>
					<i class="cl_violet f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</i>
					<i class="cl_violet f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</i>
					<img src="../../static/select_gray.png" />
					<div class="public_header_hide bg_white tc f16px">
						<ul>
							<li><router-link to="/personal">我的账号</router-link></li>
							<li><router-link to="/order">我的订单</router-link></li>
						</ul>
					</div>
				</div>
				<button class="cl_dark" @click="signOut">退出登录</button>
			</div>
			<div class="public_header_r" v-else>
				<router-link to="/" class="public_header_vip cl_violet f16px">登录</router-link>
				&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/logon" class="public_header_vip cl_violet f16px">注册</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'public_header',
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
			}
		},
		mounted() {
			if (localStorage.getItem("token")) {
				this.getInfo();
			}
		},
		methods: {
			getInfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
					that.$emit("child-event", that.myInfo)
				});
			},
			//退出
			signOut () {
				localStorage.removeItem("token");
				this.$router.push({ path: "/" });
			},
		},
	}
</script>

<style>
</style>
